import { ApiError } from '../api/client'
import { asSentence, formatWait } from '../lib/format'
import { AuthApiError } from './authApi'

export const NETWORK_ERROR_MESSAGE = 'Could not reach the server. Check your connection and try again.'

export { formatWait }

/** A ticking countdown: "27s", "4:05", "1:02:03". */
export function formatCountdown(seconds: number): string {
  const whole = Math.max(0, Math.ceil(seconds))
  if (whole < 60) return `${whole}s`
  const hours = Math.floor(whole / 3600)
  const minutes = Math.floor((whole % 3600) / 60)
  const secs = String(whole % 60).padStart(2, '0')
  return hours > 0 ? `${hours}:${String(minutes).padStart(2, '0')}:${secs}` : `${minutes}:${secs}`
}

/**
 * What to tell people when a sign-in call fails: the server's own message (400, 503, ...), with the
 * wait added for 429, or a connection hint when the request never got an answer.
 */
export function describeAuthError(error: unknown): string {
  if (error instanceof AuthApiError && error.status === 429 && error.retryAfter !== null) {
    return `${asSentence(error.message)} Try again in ${formatWait(error.retryAfter)}.`
  }
  if (error instanceof ApiError) return asSentence(error.message)
  return NETWORK_ERROR_MESSAGE
}
